"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSizeme = _interopRequireDefault(require("react-sizeme"));
var _md = _interopRequireDefault(require("md5"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _once2 = _interopRequireDefault(require("lodash/once"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    /** Calculate hash based on the DOM path to the component */
    _defineProperty(_this, "getHash", (0, _once2["default"])(function () {
      var xpath = '';
      var _getNode = function getNode(node) {
        xpath = (node.type.name || '') + '_' + xpath;
        if (node._debugOwner) {
          _getNode(node._debugOwner);
        }
      };
      _getNode(_this._reactInternalFiber);
      var hash = (0, _md["default"])(window.location.path + ':' + xpath + ':' + _this.props.handle).substr(-5);
      return hash;
    }));
    _defineProperty(_this, "getCachedWidth", function () {
      var hash = _this.getHash();
      return (0, _get2["default"])(window, "cccisd.components.responsive.".concat(hash, ".width"));
    });
    _defineProperty(_this, "getClassName", function () {
      var _this$props = _this.props,
        size = _this$props.size,
        stylesheet = _this$props.stylesheet,
        widthBreakpoints = _this$props.widthBreakpoints;
      if (!stylesheet) {
        return '';
      }
      var width = size.width || _this.getCachedWidth();
      if (!width) {
        return '';
      }
      var result = '';
      if (width < widthBreakpoints.xsmall) {
        result = stylesheet.xsmall || '';
      } else if (width <= widthBreakpoints.small) {
        result = stylesheet.small || '';
      } else if (width <= widthBreakpoints.medium) {
        result = stylesheet.medium || '';
      } else {
        result = stylesheet.large || '';
      }
      return result;
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // save width in cache
      if (this.props.size.width !== prevProps.size.width && typeof this.props.size.width === 'number' && this.props.size.width > 0) {
        var hash = this.getHash();
        (0, _set2["default"])(window, "cccisd.components.responsive.".concat(hash, ".width"), this.props.size.width);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isWidthCalculated = typeof this.props.size.width === 'number' || typeof this.getCachedWidth() === 'number';
      var size = this.props.size;
      var width = size.width || this.getCachedWidth();

      // We need extra div to calculate size properly
      var result = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName(),
        style: {
          display: isWidthCalculated ? 'block' : 'none'
        }
      }, this.props.render ? this.props.render({
        width: width
      }) : this.props.children));
      if (this.props.showSizeWrapper) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].wrapper
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].info
        }, "Width: ", this.props.size.width), result);
      }
      return result;
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  size: _propTypes["default"].object,
  children: _propTypes["default"].node,
  /** Unique string helping for saving calculated size in cache */
  handle: _propTypes["default"].string,
  /** CSS Module Stylesheet */
  stylesheet: _propTypes["default"].object.isRequired,
  /** @ignore Shows the width of the responsive wrapper in the upper right corner when true. */
  showSizeWrapper: _propTypes["default"].bool,
  /** Allows the user to alter the breakpoints for the size classes above. */
  widthBreakpoints: _propTypes["default"].object,
  render: _propTypes["default"].func
});
_defineProperty(Component, "defaultProps", {
  size: {},
  handle: 'handle',
  showSizeWrapper: false,
  widthBreakpoints: {
    xsmall: 768,
    small: 992,
    medium: 1200
  }
});
var _default = exports["default"] = (0, _reactSizeme["default"])({
  noPlaceholder: true
})(Component);